import { t } from "@lingui/core/macro";

import { AsyncButton } from "@/shared/components/ui/async-button";
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/shared/components/ui/dialog";
import { Textarea } from "@/shared/components/ui/textarea";

type FeedbackDialogPromptProps = {
  source: "feedbackLink" | "errorBoundary";
  feedback: string;
  isLoading: boolean;
  onFeedbackChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onSendFeedback: () => void;
};

export default function FeedbackDialogPrompt({
  source,
  feedback,
  isLoading,
  onFeedbackChange,
  onSendFeedback,
}: FeedbackDialogPromptProps) {
  return (
    <>
      <DialogHeader>
        <DialogTitle>{source === "errorBoundary" ? t`Report Issue` : t`Give feedback`}</DialogTitle>
        {source !== "errorBoundary" && (
          <DialogDescription>
            {t`We are committed to providing you with the best client experience possible. Your feedback helps us improve. Please share your suggestions or report any issues so our team can review.`}
          </DialogDescription>
        )}
      </DialogHeader>
      <Textarea value={feedback} onChange={onFeedbackChange} />
      <DialogFooter>
        <AsyncButton variant="ghost" onClick={onSendFeedback} loading={isLoading}>
          {t`Submit`}
        </AsyncButton>
      </DialogFooter>
    </>
  );
}
